import { render } from "./NavigationBarComponent.vue?vue&type=template&id=64c14ba3"
import script from "./NavigationBarComponent.vue?vue&type=script&lang=js"
export * from "./NavigationBarComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__